export enum AccountMergingStepName {
  VERIFY_OTP = 'verifyOtp',
  ADD_MOBILE_NUMBER = 'addMobileNumber',
  ACCOUNT_EXISTS = 'accountExists',
  MERGE_ACCOUNT = 'mergeAccount',
  MERGE_SUCCESS = 'mergeSuccess',
}

export enum CheckExistenceApiError {
  INVALID_TOKEN = 'invalidToken',
  NETWORK_ERROR = 'networkError',
  RATE_LIMIT = 'suspiciousOrRateLimited',
  OTHER_ERROR = 'otherErrors',
  RETRIES_EXHAUSTED = 'retriesExhausted',
}
export interface AccountMergingStep {
  stepName: AccountMergingStepName;
  error?: string;
  sendOtpExhausted?: boolean;
  otpLength?: number;
  otpId?: string;
  rewardsPoints1?: number;
  rewardsPoints2?: number;
  finalRewardsPoints?: number;
  walletBalance1?: number;
  walletBalance2?: number;
  finalWalletBalance?: number;
}

export interface AccountMergingState {
  steps: AccountMergingStep[];
  isExists?: boolean;
  linkedEmail?: string;
  mobileNumber: string;
  emailId?: string;
  changeMob: boolean;
  previousPageName?: string;
  root: string;
}

export interface ErrorInApi {
  messageToDisplay?: string;
  errorToLog: string;
}

export enum GetMergingStatusError {
  INVALID_TOKEN = 'invalidToken',
  NETWORK_ERROR = 'networkError',
  OTHER_ERROR = 'otherErrors',
  GUEST_USER = 'guestUser',
  NOT_ELIGIBLE = 'notEligible',
}

export interface ErrorInGetMergingStatusApi extends ErrorInApi {
  type: GetMergingStatusError;
  takeToHome?: boolean;
}

export enum MobileMappingStatus {
  GUEST_USER = '0',
  VERIFIED = '1',
  MULTIPLE_OR_NO_MOBILE = '2',
  SUGGEST_MOBILE_NUMBER = '3',
  UN_VERIFIED_MOBILE = '5',
  ALREADY_LINKED = '4',
  ERROR = 'error',
}

export interface MobileMergingResponse {
  error?: ErrorInGetMergingStatusApi;
  status?: string;
  otpId: string;
  retryAllowed: number;
  resendAllowed: number;
  validity: number;
}

// * SEND MOBILE MAPPING OTP
export enum SendMergingOTPError {
  INVALID_TOKEN = 'invalidToken',
  NETWORK_ERROR = 'networkError',
  RATE_LIMIT = 'suspiciousOrRateLimited',
  OTHER_ERROR = 'otherErrors',
  RETRIES_EXHAUSTED = 'retriesExhausted',
}

export interface SendMergingOtpErrorInApi extends ErrorInApi {
  type: SendMergingOTPError;
}

export enum SendMergingOTPStatus {
  SUCCESS = 'success',
  RETRIES_EXHAUSTED = 'retriesExhausted',
  OTHERS = 'other',
  FAIL = 'fail',
}

export interface SendMergingOTPResponse {
  error?: SendMergingOtpErrorInApi;
  status?: SendMergingOTPStatus;
  message?: string;
  otpId?: string;
  retryAllowed?: number;
  resendAllowed?: number;
  validity?: number;
}

export interface ResendMergingOTPResponse {
  error?: SendMergingOtpErrorInApi;
  status?: SendMergingOTPStatus;
  message?: string;
  otpId?: string;
  resendAllowed?: number;
}

export enum VerifyMappingOtpStatus {
  SUCCESS = 'success',
  RETRIES_EXHAUSTED = 'retriesExhausted',
  ERROR = 'error',
  FAIL = 'fail',
}

export enum VerifyMappingOtpError {
  AUTHENTICATION_FAILED = 'authenticationFailed',
  FRAUD_LISTED = 'numberInFraudList',
  VERIFICATION_FAILED = 'otpVerificationFailed',
  EXHAUSTED_VERIFY_ATTEMPTS = 'verifyTriesExceeded',
  NETWORK_ERROR = 'networkError',
  OTHER = 'otherError',
}

export interface VerifyMappingOtpErrorInApi extends ErrorInApi {
  type: VerifyMappingOtpError;
}

export interface VerifyMappingOtpResponse {
  error?: VerifyMappingOtpErrorInApi;
  status?: VerifyMappingOtpStatus;
  message?: string;
}

export interface VerifyMergingOtpResponse {
  error?: VerifyMappingOtpErrorInApi;
  status?: VerifyMappingOtpStatus;
  otpId?: string;
  retryLeft?: number;
}

export interface VerifyMergingAccountOtpResponse {
  error?: VerifyMappingOtpErrorInApi;
  status?: VerifyMappingOtpStatus;
  rewardsPoints1?: number;
  rewardsPoints2?: number;
  finalRewardsPoints?: number;
  walletBalance1?: number;
  walletBalance2?: number;
  finalWalletBalance?: number;
}

export interface SendMappingOtpRequestParams {
  mobileNumber: string;
  isNew?: boolean;
}
